var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroll",staticStyle:{"overflow":"hidden","width":"100%","height":"100%"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }